import jquery from "jquery";
window.$ = jquery;
window.jQuery = jquery;
// require("@rails/ujs").start();
require("@rails/activestorage").start();
require("@hotwired/turbo");
Turbo.setFormMode("optin");
require("./parsley")
require("./main");
require("./rails.validations");
